import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/task_definitions',
  component: Management,
  redirect: '/task_definitions/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/task_definitions/List'),
      meta: {
        auth: Auth.listTaskDefinitions
      },
      redirect: 'list/all',
      children: [
        {
          path: 'all',
          component: () => import('@/views/task_definitions/ListTable'),
          meta: {
            auth: Auth.listTaskDefinitions,
            tabName: 'all'
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/task_definitions/New'),
      meta: {
        auth: Auth.createTaskDefinition
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/task_definitions/Edit'),
      meta: {
        auth: Auth.updateTaskDefinition
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/task_definitions/DetailLayout'),
      meta: {
        auth: Auth.showTaskDefinition
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/task_definitions/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showTaskDefinition
          }
        },
        // 参与记录
        {
          path: 'participations',
          component: () => import('@/views/task_definitions/details/EcaRuleOutcomes'),
          meta: {
            tabName: 'outcomes', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showTaskDefinition
          }
        }
      ]
    }
  ]
}
